import { Box, Pagination } from '@primer/react';
import clsx from 'clsx';
import { useContext } from 'react';
import { DataTableContainerContext, IDataTableContext } from './DataTable';
import styles from "./DataTable.module.css";
import Button from '../button';
const Paging = () => {
    const { props, pageIndex, pageSize, setPageIndex, setPageSize, pageCount } = useContext<IDataTableContext>(DataTableContainerContext);
    return (
        <>
            <Box
                id="paging"
                className={clsx(styles.pagingContainer)}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    // minHeight: "30px"
                }}
            >
                <Box sx={{ flex: 1 }}>
                    {props.paging?.pageSizeItems && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    fontSize: "11px",
                                    color: "fg.muted",
                                }}
                            >
                                Page size&nbsp;&nbsp;
                            </Box>
                            {props.paging?.pageSizeItems.map((x) => {
                                return (
                                    <Button
                                        key={x}
                                        className={clsx(
                                            styles.pageSize,
                                            x === pageSize ? styles.selected : ""
                                        )}
                                        variant="invisible"
                                        sx={{
                                            color: "fg.default",
                                            fontWeight: 400,
                                        }}
                                        size="small"
                                        onClick={() => {
                                            setPageSize(x);
                                            setPageIndex(0);
                                        }}
                                    >
                                        {x.toString()}
                                    </Button>
                                );
                            })}
                        </Box>
                    )}
                </Box>
                <Box id="info" sx={{ width: "100px", textAlign: "center" }}>
                    <Box
                        sx={{
                            color: "fg.muted",
                        }}
                    >
                        {pageIndex * pageSize + 1} -{" "}
                        {(pageIndex + 1) * pageSize > props.data.length
                            ? props.data.length
                            : (pageIndex + 1) * pageSize}{" "}
                        of {props.data.length}
                    </Box>
                </Box>
                <Box
                    sx={{ flex: 1, display: "flex", flexDirection: "row-reverse" }}
                >
                    {pageCount > 1 && (
                        <Pagination
                            pageCount={pageCount}
                            currentPage={pageIndex + 1}
                            showPages={{
                                narrow: false,
                            }}
                            onPageChange={(e, n) => {
                                setPageIndex(n - 1);
                            }}
                        />
                    )}
                </Box>
            </Box>
        </>
    );
};

export default Paging;